// What a newcomer answered BEFORE giving their email (Liam 30 Sep 2026: "do some of the onboarding before they
// sign up"; planned with Astra: one question, how they mostly message customers). Kept on this phone only, never
// sent anywhere until the round is made, and only ever used to FILL IN the set-up screen, where they see it and
// can change it (a draft left on a shared phone is never applied quietly). Forgotten after the sign-up, and
// ignored once it is a week old. Nothing here is counted or tracked (the privacy page says no visitor tracking).

import type { MessageBy } from './contact'
import type { Trade } from './trade'

const KEY = 'roundly.signupDraft'
const WEEK_MS = 7 * 24 * 60 * 60 * 1000

export interface SignupDraft {
  message_by: MessageBy
}

export function saveSignupDraft(d: SignupDraft, now = Date.now()): void {
  try { localStorage.setItem(KEY, JSON.stringify({ message_by: d.message_by, at: now })) } catch { /* private window: they are asked again on set-up */ }
}

export function signupDraft(now = Date.now()): SignupDraft | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const o = JSON.parse(raw) as { message_by?: unknown; at?: unknown }
    if (typeof o.at !== 'number' || now - o.at > WEEK_MS || o.at > now + 60_000) return null
    if (o.message_by !== 'text' && o.message_by !== 'whatsapp' && o.message_by !== 'email') return null
    return { message_by: o.message_by }
  } catch {
    return null
  }
}

export function forgetSignupDraft(): void {
  try { localStorage.removeItem(KEY) } catch { /* nothing kept */ }
}

// The kind of round the website page suggests: its sign-up links carry the page's tag (signup-from.ts), and the
// gardening and cleaning pages' tags start "gardening" and "cleaning". Anything else: window cleaning, as before.
export function tradeFromTag(tag: string | null): Trade | null {
  if (!tag) return null
  if (/^gardening(-|$)/.test(tag)) return 'gardening'
  if (/^cleaning(-|$)/.test(tag)) return 'cleaning'
  return null
}
